import axios from 'axios'
import { clearAllCookies } from '@/utils/tools'

const _axios = axios.create({
  baseURL: process.env.VUE_API,
  //   baseURL: 'http://10.10.107.154:8091/',
  // baseURL: 'http://cmsapi.uat4pis.com',
  withCredentials: true
})

_axios.interceptors.response.use(
  async (res) => {
    // console.log('未登录',res.data.status)
    // console.log(res)
    if (res.status == 200) { //接口可用
      if (res.data.code == 200|| res.data.status == 200) {
        return res.data
      } else {
        console.log('未登录',res)
        // await clearAllCookies()
        sessionStorage.clear()
        return res.data
      }
      // return res.data
    } else {
      console.log('失败')
    }


    // else if (res.status ==200 && res.data.status == 9000) {
    //   console.log('未登录')
    //   //清除所有的cookie
    //   await clearAllCookies()
    //    return res.data
    // }
  },
  (error) => {

    return Promise.reject(error)
  }
)
// _axios.interceptors.request.use(
//   (config) => {

//     // Bearer
//     // Authorizatio        store.state.user.token

//     if (localStorage.getItem('sa-token')) {
//       config.headers['sa-token'] = window.localStorage.getItem('sa-token')
//     }
//     return config
//   },
//   (error) => {
//     return Promise.reject(error)
//   }
// )
// _axios.interceptors.response.use(
//   (res) => {
//     console.log(res.data.status)
//     if (res.data.status ==401) {
//       location.replace('/login')
//     }else{
//       return res // .data
//     }
//   },
//   (error) => {
//     return Promise.reject(error)
//   }
// )

export default _axios
